import { render } from "./ProjectSingle.vue?vue&type=template&id=cd16e336"
import script from "./ProjectSingle.vue?vue&type=script&lang=js"
export * from "./ProjectSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__